function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
  requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
  x: 0,
  y: 0,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("g", {
  iExtraneous: "self"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "80.6,41.4 73,33.7 55.4,51.3 55.4,2.5 44.6,2.5 44.6,51.3 27,33.7 19.4,41.4 50,72    "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "85.7,66 85.7,86.7 14.3,86.7 14.3,66 3.5,66 3.5,97.5 96.5,97.5 96.5,66    "
}))));

function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsX: "http://ns.adobe.com/Extensibility/1.0/",
    xmlnsI: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    xmlnsGraph: "http://ns.adobe.com/Graphs/1.0/",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.87fcf9fa.svg";
export { ForwardRef as ReactComponent };